import { IonicVue } from '@ionic/vue';

export default IonicVue;
